export default {
  error: 'Fehler',
  sorry: 'Leider haben wir folgende Fehler empfangen',
  workingOnIt:
    'Ein Ingenieur ist bereit über dieses Problem informiert, und wir arbeiten so schnell wie möglich an einer Lösung.',
  tryAgain: 'Bitte versuchen Sie es später noch einmal',
  noInternet:
    'Es scheint ein Problem mit Ihrer Internetverbindung zu geben. Bitte überprüfen Sie es und versuchen Sie es erneut.',
}
